import { render, staticRenderFns } from "./PsItemMenu.vue?vue&type=template&id=4abeb34d&scoped=true&"
import script from "./PsItemMenu.vue?vue&type=script&lang=js&"
export * from "./PsItemMenu.vue?vue&type=script&lang=js&"
import style0 from "./PsItemMenu.vue?vue&type=style&index=0&id=4abeb34d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abeb34d",
  null
  
)

export default component.exports